import CommonDropdownMenu from "./menu/CommonDropdownMenu";
import MenuLink from "./menu/MenuLink";
import { useTranslation } from "@/hooks/localization/useTranslations";
interface Props {
  isMobile: boolean;
}
const TopWinnerSpecial: React.FC<Props> = ({ isMobile }) => {
  const t = useTranslation();
  const topWinnerAboutUs = [
    { title: t.about_dr, href: "/about-us/about-dr-hamdan" },
    { title: t.about_us, href: "/about-us" },
  ];
  return (
    <CommonDropdownMenu title={{ text: t?.about_us }} isMobile={isMobile} down>
      {topWinnerAboutUs?.map((item, key) => (
        <MenuLink
          isMobile={isMobile}
          key={key}
          href={item.href}
          title={{ text: item.title }}
        />
      ))}
    </CommonDropdownMenu>
  );
};

export default TopWinnerSpecial;
